import api from 'services/api';

export default async function getAllActivities() {
  const response = await api.get('/activities', {});

  return response.data;
}
